import { render } from "./goodMain.vue?vue&type=template&id=64317974&scoped=true"
import script from "./goodMain.vue?vue&type=script&lang=js"
export * from "./goodMain.vue?vue&type=script&lang=js"

import "./goodMain.vue?vue&type=style&index=0&id=64317974&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64317974"]])

export default __exports__